module.exports = __webpack_public_path__ + "static/media/WellLife_Program_Grid.e4965d62.pdf";